import { supabase } from '@/integrations/supabase/client';

const BUCKET = 'user-avatars';
const MAX_SIZE_BYTES = 2 * 1024 * 1024; // 2 MB
const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export interface AvatarUploadResult {
  publicUrl: string;
  path: string;
}

/**
 * Upload a user avatar to the user-avatars bucket.
 * Path: {userId}/{random}.{ext}
 * Returns the public URL.
 */
export async function uploadUserAvatar(
  userId: string,
  file: File
): Promise<AvatarUploadResult> {
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error('Filtypen stöds inte. Använd JPG, PNG eller WebP.');
  }
  if (file.size > MAX_SIZE_BYTES) {
    throw new Error('Bilden är för stor. Max 2 MB.');
  }

  const ext = file.name.split('.').pop()?.toLowerCase() || 'jpg';
  const path = `${userId}/${crypto.randomUUID()}.${ext}`;

  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    cacheControl: '3600',
    upsert: false,
  });

  if (error) throw error;

  const { data: urlData } = supabase.storage.from(BUCKET).getPublicUrl(path);

  return { publicUrl: urlData.publicUrl, path };
}
